import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Alert from 'flarum/common/components/Alert';

/**
 * 手机短信登录 / 注册弹窗。
 * 1) 输入手机号点「获取验证码」-> POST /api/auth/sms/send
 * 2) 输入验证码点「登录」-> POST /api/auth/sms/verify 拿 token
 * 3) 前端 app.session.store(token, userId) 写入会话并刷新页面
 */
export default class SmsLoginModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.phone = '';
    this.code = '';
    this.sending = false;
    this.loading = false;
    this.error = null;
    this.msg = null;
  }

  className() {
    return 'SmsLoginModal Modal--small';
  }

  title() {
    return '手机短信登录 / 注册';
  }

  content() {
    return (
      <div className="Modal-body">
        {this.error && Alert.component({ type: 'error', children: this.error })}
        {this.msg && Alert.component({ type: 'success', children: this.msg })}

        <div className="Form-group">
          <label for="sms-phone">手机号</label>
          <input
            id="sms-phone"
            className="FormControl"
            type="tel"
            autocomplete="tel"
            placeholder="请输入手机号"
            value={this.phone}
            oninput={(e) => (this.phone = e.target.value)}
          />
        </div>

        <div className="Form-group">
          <label for="sms-code">短信验证码</label>
          <div className="AcmeSmsCodeRow">
            <input
              id="sms-code"
              className="FormControl"
              autocomplete="one-time-code"
              placeholder="请输入验证码"
              value={this.code}
              oninput={(e) => (this.code = e.target.value)}
            />
            <Button className="Button Button--primary" loading={this.sending} onclick={() => this.send()}>
              获取验证码
            </Button>
          </div>
        </div>

        <div className="Form-group">
          <Button className="Button Button--primary Button--block" loading={this.loading} onclick={() => this.verify()}>
            登录 / 注册
          </Button>
        </div>

        <p className="helpText">首次使用该手机号将自动注册新账号。</p>
      </div>
    );
  }

  send() {
    this.sending = true;
    this.error = null;
    this.msg = null;

    app.request({
      method: 'POST',
      url: '/api/auth/sms/send',
      body: { phone: this.phone },
    })
      .then(() => {
        this.msg = '验证码已发送，请查收短信（5 分钟内有效）';
      })
      .catch((err) => {
        this.error = (err.responseJSON && err.responseJSON.message) || '发送失败，请稍后再试';
      })
      .finally(() => {
        this.sending = false;
        m.redraw();
      });
  }

  verify() {
    this.loading = true;
    this.error = null;

    app.request({
      method: 'POST',
      url: '/api/auth/sms/verify',
      body: { phone: this.phone, code: this.code },
    })
      .then(() => {
        // 后端已在当前 session 中写入 access_token 并种下 cookie，
        // 这里直接刷新即可进入登录态（不要用 app.session.store，Flarum 没有这个 API）。
        this.hide();
        window.location.reload();
      })
      .catch((err) => {
        this.error = (err.responseJSON && err.responseJSON.message) || '验证失败';
      })
      .finally(() => {
        this.loading = false;
        m.redraw();
      });
  }
}
